import { getClient } from '@/lib/restClient';
import { MenuManagementBrandCategoryService } from '@/services/BrandCategory/MenuManagementBrandCategoryService';

export const useMenuManagementDeleteBrandCategory = async (
  id: string
): Promise<void> => {
  const menuManagementBrandCategoryService =
    new MenuManagementBrandCategoryService(getClient());

  return menuManagementBrandCategoryService.delete(id);
};
